import { jsx as t, jsxs as P, Fragment as y } from "react/jsx-runtime";
import { useRef as L, useState as j } from "react";
import A from "@mui/material/Box";
import { Popper as O, Grow as R, ClickAwayListener as S, MenuList as z } from "@mui/material";
import "@fortawesome/pro-solid-svg-icons/faCheck";
import "@fortawesome/pro-regular-svg-icons/faCircleQuestion";
import "@mui/material/styles";
import "@mui/material/CssBaseline";
import { w as B, i as F } from "./Slider-vVmtecg6.js";
import "@mui/material/useAutocomplete";
import "@fortawesome/pro-regular-svg-icons";
import "@emotion/cache";
import "@emotion/react";
import "@mui/material/Typography";
import "@fortawesome/react-fontawesome";
import "@fortawesome/fontawesome-svg-core";
import "@mui/material/Checkbox";
import "@fortawesome/pro-solid-svg-icons";
import "@fortawesome/pro-light-svg-icons";
import "@mui/material/Stack";
import "@mui/material/Link";
import "@mui/material/Tooltip";
import "@mui/material/Fade";
import "@mui/material/Button";
import "@fortawesome/pro-regular-svg-icons/faXmark";
import "@fortawesome/pro-solid-svg-icons/faCircle";
import "@mui/material/Chip";
import "@mui/material/Avatar";
import "@fortawesome/pro-light-svg-icons/faUser";
import "@mui/material/AvatarGroup";
import "@fortawesome/pro-regular-svg-icons/faPlus";
import "@mui/material/LinearProgress";
import "@mui/material/Tabs";
import "@mui/material/Tab";
import "./Tab-CO75KpXL.js";
import "@mui/material/ButtonGroup";
import "@mui/material/Switch";
import "@mui/material/Radio";
import "@mui/material/FormLabel";
import "@mui/material/Autocomplete";
import "@mui/material/FormHelperText";
import "@mui/material/FormControl";
import "@mui/material/OutlinedInput";
import "@mui/material/Input";
import "@mui/material/InputAdornment";
import "@fortawesome/pro-regular-svg-icons/faMagnifyingGlass";
import "@react-spring/web";
import "./ContentPanel-DRC79oum.js";
import "react-dropzone";
import "@vidstack/react";
import "@vidstack/react/player/layouts/default";
import "@vidstack/react/player/styles/default/theme.css";
import "@vidstack/react/player/styles/default/layouts/video.css";
import "@vidstack/react/icons";
import "@fortawesome/pro-light-svg-icons/faArrowUpRightFromSquare";
import "@fortawesome/pro-solid-svg-icons/faArrowRight";
import "@mui/material/Popper";
import "@fortawesome/pro-regular-svg-icons/faLinkSimple";
import "copy-text-to-clipboard";
import "@fortawesome/pro-solid-svg-icons/faExpandWide";
import "@fortawesome/pro-solid-svg-icons/faCompressWide";
import "@fortawesome/pro-solid-svg-icons/faUpRightAndDownLeftFromCenter";
import "@fortawesome/pro-solid-svg-icons/faDownLeftAndUpRightToCenter";
import "@fortawesome/pro-solid-svg-icons/faChevronsRight";
import "@fortawesome/pro-solid-svg-icons/faChevronsLeft";
import "@fortawesome/pro-solid-svg-icons/faToggleLargeOn";
import "@fortawesome/pro-solid-svg-icons/faToggleOff";
import "@fortawesome/pro-solid-svg-icons/faEye";
import "react-use";
import "color";
import "react-rnd";
import "react-hotkeys-hook";
import "./AutoScrollContainer-CzyjIY1o.js";
import "@tanstack/react-table";
import "@fortawesome/pro-regular-svg-icons/faArrowRight";
import "@fortawesome/pro-regular-svg-icons/faArrowLeft";
import "@fortawesome/pro-regular-svg-icons/faPenToSquare";
import "@fortawesome/pro-regular-svg-icons/faCircleXmark";
import "@fortawesome/pro-regular-svg-icons/faArrowDown";
import "@mui/material/Slider";
const G = ({
  anchorEl: r,
  isOpen: a,
  textColor: n = void 0,
  textFontSize: u = void 0,
  textFontWeight: c = void 0,
  shouldDisablePortal: f = !0,
  options: v,
  dropdownMarginTop: h = void 0,
  placement: w = "bottom-end",
  maxTooltipWidth: x = void 0,
  dropdownMaxWidth: g = void 0,
  hasOptionCheckIcon: I = !1,
  dropdownWidth: k = void 0,
  menuListZindex: m = void 0,
  dropdownMaxHeight: d = void 0,
  onClose: p = () => {
  },
  onMenuItemSelect: C = () => {
  },
  shouldCloseOnSelect: s = !0
}) => {
  const l = (i) => {
    r != null && r.contains(i.target) || p();
  }, e = (i, o) => {
    C(i, o), s && p();
  };
  return /* @__PURE__ */ t(
    O,
    {
      anchorEl: r,
      open: a,
      placement: w,
      transition: !0,
      disablePortal: f,
      sx: { zIndex: m, width: k },
      children: ({ TransitionProps: i }) => /* @__PURE__ */ t(R, { ...i, children: /* @__PURE__ */ t(
        B,
        {
          sx: {
            marginTop: h,
            ...!!d && { maxHeight: d, overflowY: "auto" }
          },
          children: /* @__PURE__ */ t(S, { onClickAway: l, children: /* @__PURE__ */ t(
            z,
            {
              disablePadding: !0,
              role: "list",
              children: v.map((o, b) => /* @__PURE__ */ t(
                F,
                {
                  ...o,
                  maxWidth: g,
                  textColor: n,
                  textFontSize: u,
                  textFontWeight: c,
                  onClick: () => {
                    e(o, b);
                  },
                  hasOptionCheckIcon: I,
                  maxTooltipWidth: x
                },
                o.value
              ))
            }
          ) })
        }
      ) })
    }
  );
}, li = ({
  children: r = null,
  shouldDisablePortal: a = !0,
  options: n,
  textColor: u = void 0,
  dropdownMarginTop: c = void 0,
  placement: f = "bottom-end",
  maxTooltipWidth: v = void 0,
  dropdownMaxWidth: h = void 0,
  hasOptionCheckIcon: w = !1,
  dropdownWidth: x = void 0,
  menuListZindex: g = void 0,
  dropdownMaxHeight: I = void 0,
  onOpen: k = () => {
  },
  onClose: m = () => {
  },
  onMenuItemSelect: d = () => {
  },
  shouldCloseOnSelect: p = !0,
  isDisabled: C = !1
}) => {
  const s = L(null), [l, e] = j(!1), i = (D, M) => {
    d(D, M), p && (e(!1), m());
  }, o = () => {
    m(), e(!1);
  }, b = () => {
    l ? m() : k(), e((D) => !D);
  };
  return /* @__PURE__ */ P(y, { children: [
    /* @__PURE__ */ t(
      A,
      {
        ref: s,
        onClick: () => {
          !n.length || C || b();
        },
        children: r
      }
    ),
    /* @__PURE__ */ t(
      G,
      {
        anchorEl: s.current,
        isOpen: l,
        onClose: o,
        textColor: u,
        onMenuItemSelect: i,
        options: n,
        shouldDisablePortal: a,
        shouldCloseOnSelect: p,
        dropdownMarginTop: c,
        placement: f,
        maxTooltipWidth: v,
        dropdownMaxWidth: h,
        hasOptionCheckIcon: w,
        dropdownMaxHeight: I,
        dropdownWidth: x,
        menuListZindex: g
      }
    )
  ] });
};
export {
  li as D,
  G as a
};
